import JSEncrypt from "jsencrypt";
import { COOKIE, RSA } from "../common/constants";

export function getCookieDetails(samsungPayCookie) {
  const cookiesArray = samsungPayCookie.split(";").map((cookie) => cookie.trim());
  const cookiesHashmap = cookiesArray.reduce((all, cookie) => {
    var [key, value] = cookie.split("=");
    
    if (key === COOKIE.KEY) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(RSA.PUBLIC_KEY);

      value = jsEncrypt.encrypt(value);
    }

    return {
      [key]: value,
      ...all,
    };
  }, {});

  return cookiesHashmap;
}